"use client";

import { Ecommerce } from "@/lib/nexus-app";
import { useTranslations } from "next-intl";
import { useState } from "react";
import Image from "next/image";
import { isUnoptimizable } from "@/utils/image";
import { useStoreRecheck } from "@/components/StoreStatusProvider/StoreStatusProvider";

export default function StorePausedDialog({ ecommerce }: { ecommerce: Ecommerce }) {
  const t = useTranslations("StoreClosed");
  const [dismissed, setDismissed] = useState(false);
  const { checking, stillPaused, check } = useStoreRecheck();

  if (dismissed) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-6 backdrop-blur-sm">
      <div className="w-full flex flex-col items-center justify-center max-w-xl rounded-2xl border border-gray-3 bg-white p-6 shadow-2xl animate-in fade-in zoom-in duration-300">
        <h1 className="text-xl font-semibold text-center">{t("pausedTitle")}</h1>

        <p className="mt-2 text-sm text-gray-600 text-center">{t("pausedText")}</p>

        {ecommerce.logo ? (
          <Image
            width={200}
            height={200}
            src={ecommerce.logo}
            alt={ecommerce.name}
            unoptimized={isUnoptimizable(ecommerce.logo)}
            className="mt-6 h-14 w-auto"
          />
        ) : null}

        <p className="mt-4 text-xs text-gray-500">{ecommerce.name}</p>

        {stillPaused && (
          <p className="mt-4 text-sm text-orange-700 text-center">{t("stillPaused")}</p>
        )}

        <button
          onClick={check}
          disabled={checking}
          className="mt-8 w-full bg-blue text-white font-semibold py-3 px-6 rounded-xl hover:bg-blue-dark transition-colors shadow-lg shadow-blue/20 disabled:opacity-60"
        >
          {checking ? t("checking") : t("checkAgain")}
        </button>

        <button
          onClick={() => setDismissed(true)}
          className="mt-3 w-full font-semibold py-3 px-6 rounded-xl border border-gray-3 text-dark hover:bg-gray-1 transition-colors"
        >
          {t("browseMenu")}
        </button>
      </div>
    </div>
  );
}
